function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { View } from 'react-native';
import { CalendarPickerRow } from "./calendarPickerRow.component";
import { CalendarPickerCell } from "./calendarPickerCell.component";
export class CalendarPicker extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "isFirstRangeItem", (item, range) => {
      return range.indexOf(item) === 0;
    });

    _defineProperty(this, "isLastRangeItem", (item, range) => {
      return range.indexOf(item) === range.length - 1;
    });

    _defineProperty(this, "renderCellElement", (item, index) => {
      const isFirstRangeItem = this.isFirstRangeItem(item, this.rangedArray);
      const isLastRangeItem = this.isLastRangeItem(item, this.rangedArray);
      return /*#__PURE__*/React.createElement(CalendarPickerCell, {
        key: index,
        date: item,
        selected: this.props.isItemSelected(item),
        disabled: this.props.isItemDisabled(item),
        bounding: item.bounding,
        today: this.props.isItemToday(item),
        range: item.range,
        firstRangeItem: isFirstRangeItem,
        lastRangeItem: isLastRangeItem,
        onSelect: this.props.onSelect,
        shouldComponentUpdate: this.props.shouldItemUpdate
      }, this.props.children);
    });

    _defineProperty(this, "renderRowElement", (item, index) => {
      return /*#__PURE__*/React.createElement(CalendarPickerRow, {
        key: index,
        style: this.props.rowStyle,
        data: item
      }, this.renderCellElement);
    });
  }

  get rangedArray() {
    const {
      data
    } = this.props;
    return [].concat(...data).filter(item => {
      return item.range;
    });
  }

  render() {
    const _this$props = this.props,
          {
      data,
      children
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["data", "children"]);

    return /*#__PURE__*/React.createElement(View, viewProps, data.map(this.renderRowElement));
  }

}